<template>
  <v-menu
    top
    offset-y
    :menu-props="{ bottom: true, offsetY: true }"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn dark icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
            <v-icon color="white">mdi-dots-horizontal</v-icon></v-btn
          >
        </template>
        <span>{{ $t("poll.tipRemoveSection") }}</span>
      </v-tooltip>
    </template>

    <v-list dense>
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        @click="onSectionAction(item)"
      >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
    <confirm-dialog ref="confDelete" />
  </v-menu>
</template>

<script>
import { mapMutations } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
export default {
  name: "SectionDeleteMenu",
  components: {
    ConfirmDialog,
  },
  props: {
    section: Object,
  },
  data() {
    return {};
  },
  computed: {
    sectionId() {
      return this.section.sectionId;
    },
    items(){
      return [
        { text: this.$t("poll.lblRemoveSection"), value: "JustSection" },
        {
          text: this.$t("poll.lblRemoveSectionAndQuestion"),
          value: "SectionAndQuestion",
        },
      ]
    }
  },
  methods: {
    ...mapMutations({
      deleteSectionAndQuestions: "poll/DELETE_SECTION_AND_QUESTIONS",
    }),
    onSectionAction,
  },
};

async function onSectionAction(item) {
  if (item.value === "JustSection") {
    this.$emit("sectionDelete", this.section);
  }
  if (item.value === "SectionAndQuestion") {

    if (
      await this.$refs.confDelete.open(
        this.$t("agenda.hDeleteMessage"),
        this.$t("poll.msgDeleteSectionAndQuestions")
      )
    ) {
      this.deleteSectionAndQuestions(this.sectionId);
    }
  }
}
</script>

<style>
</style>